import React, { useEffect, useState } from "react";
import SearchIcon from "../../../../img/icons/search-icon.svg";
import "./style.css";
import { usePrevious } from "../../../../utilities/hooks";
import {
  findHashValue,
  hashToText,
  textToHash,
  updateHash,
} from "../../../../utilities/hash";
import { PARAMETER_VALUE } from "../../../../constants/config/hash";
import { DEBOUNCE_INTERVAL } from "../../../../constants/config/filters";
import { FILTER, LAST_FILTERED_PARAM } from "../../../../constants/config/dtm";
import { useDispatch, useSelector } from "react-redux";
import { track } from "../../../../actions/dtm";

/**
 * @name Search
 * @function
 * @description Displays Search filter
 * @returns {JSX}
 * @param {*} props
 */
const Search = (props) => {

  const { lastReset } = useSelector((state) => ({
    lastReset: state.filters.lastReset,
  }));
  const [value, setValue] = useState(props.value || ""),
    prevValue = usePrevious(value),
    prevParam = usePrevious(props.parameter),
    prevLastReset = usePrevious(lastReset);
  const dispatch = useDispatch();

  let debounce;

  useEffect(() => {
    if (props.value && props.value !== value) setValue(props.value);

    if ((prevValue && prevValue !== value) || (!prevValue && value)) {
      let hash = value.length > 0 ? textToHash(props.parameter, value) : null;
      updateHash(props.parameter, hash);
      if (hash) {
        window[LAST_FILTERED_PARAM] = hash;
        dispatch(track(props.name, value));
      }
    } else if (!prevValue || (prevParam && props.parameter !== prevParam)) {
      setInitial();
    }

    if (
      (lastReset && prevLastReset !== lastReset) ||
      (prevParam && prevParam !== props.parameter)
    )
      setValue("");
  });
  /**
   * @name setInitial
   * @function
   * @description Gets the initial value to display in the text input
   */
  function setInitial() {
    const hash = findHashValue(
      PARAMETER_VALUE.replace("{id}", props.parameter)
    );

    if (!hash) return null;

    setValue(
      hashToText(hash)
        [props.parameter].map((item) => item.value)
        .join("|")
    );
  }

  /**
   * @name apply
   * @method
   * @description Applies the filter
   * @param {EventListenerObject} e Synthetic event object
   */
  const apply = (e) => {
    const VALUE = e.target.value.replace(/%/g, "");

    if (props.debounce) {
      if (debounce) clearInterval(debounce);
      debounce = setInterval(setValue, DEBOUNCE_INTERVAL, VALUE);
    } else {
      setValue(VALUE);
    }
    
    const adobeDataName = props.name;

    const dataForAdobeDataLayer = {
      event: "PST Table Interaction",
      pstInteractionsInfo: {
        [adobeDataName]: VALUE
      }
    }
    window.adobeDataLayer = window.adobeDataLayer || [];
    window.adobeDataLayer.push(dataForAdobeDataLayer);
  };

  
  return (
    <div className="search-filter">
      <img src={SearchIcon} className="search-icon" alt="search" />
      <input
        type="text"
        className="search-box"
        aria-label={props.name}
        role="textbox"
        placeholder={
          props.placeholder ||
          props.defaultPlaceholder.replace("{name}", props.label)
        }
        value={value}
        onChange={apply}
      />
    </div>
  );
};


export default Search;
